export default __webpack_public_path__ + "static/logo-cd0b15ffb9c237ad30e9791628488448.svg";